import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import LaboratoryResultsListWrapper from './LaboratoryResultsListWrapper';
import { LaboratoryResultResult } from '../../../../graphql/graphql';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	patientId: string;
	selectedItem: LaboratoryResultResult;
}

const LaboratoryResultModal: React.FC<Props> = props => {
	return (
		<BaseModal
			title='component.laboratoryResultModal.title'
			size={Size.FULLSCREEN}
			contentStyle={{ height: '100%' }}
			{...props}>
			<LaboratoryResultsListWrapper
				patientId={props.patientId}
				selectedItem={props.selectedItem}
			/>
		</BaseModal>
	);
};

export default LaboratoryResultModal;
